/**
 * @generated SignedSource<<9fbf9881831043d9178735a46566f3ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProfileAvatarFragment$data = {
  readonly avatar: string;
  readonly fullName: string;
  readonly id: string;
  readonly isTest: boolean;
  readonly " $fragmentType": "ProfileAvatarFragment";
};
export type ProfileAvatarFragment$key = {
  readonly " $data"?: ProfileAvatarFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProfileAvatarFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileAvatarFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatar",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTest",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "995cefda1b60ea5e054269b8d8884e22";

export default node;
